import {
  ApiResponse,
  ICreateAddOnCheckoutSessionRequest,
  ICreateCheckoutSessionRequest,
  ICreateCheckoutSessionResponse,
  IUpdateSubscriptionRequest,
  IUpdateSubscriptionResponse,
} from '@/types';

import http from '../http';

export const createCheckoutSession = async (payload: ICreateCheckoutSessionRequest) =>
  http.post<ApiResponse<ICreateCheckoutSessionResponse>>(
    '/stripe/create-checkout-session',
    payload
  );

export const updateSubscription = async (payload: IUpdateSubscriptionRequest) =>
  http.post<ApiResponse<IUpdateSubscriptionResponse>>('/stripe/update-subscription', payload);

export const managePaymentMethod = async (payload: IUpdateSubscriptionRequest) =>
  http.post<ApiResponse<IUpdateSubscriptionResponse>>('/stripe/manage-payment-method', payload);

export const createAddOnCheckoutSession = async (payload: ICreateAddOnCheckoutSessionRequest) =>
  http.post<ApiResponse<ICreateCheckoutSessionResponse>>(
    '/stripe/create-addon-checkout-session',
    payload
  );
